import { colors } from '../../colors';
import Next from '../../../../static/images/icons/Next';
import Prev from '../../../../static/images/icons/Prev';
var carousel = {
  arrowBgColor: colors.salmon,
  arrowHoverBgColor: colors.wine,
  arrowForeColor: colors.white,
  arrowPrevMarginRightVarA: '4px',
  arrowNextMarginLeftVarA: '4px',
  highlightColor: colors.smoke,
  paginationInactiveColor: colors.white,
  paginationActiveColor: colors.darkSage,
  paginationBorderColor: colors.overcast,
  heroPaginationBorder: false,
  noBorderOnDesktopVariationAandB: true,
  heroPaginationInactiveColor: colors.white,
  heroPaginationInactiveColorMobile: colors.white,
  heroPaginationInactiveColorVariationC: colors.white,
  heroPaginationActiveColor: colors.salmon,
  heroPaginationBorderColor: colors.white,
  bgColor: colors.overcast,
  iconNext: Next,
  iconPrev: Prev
};
export default carousel;